import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./LoginPage.css";

function ResetPasswordPage({ setCurrentUser }) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const navigate = useNavigate();

  const evaluatePasswordStrength = (pwd) => {
    const lengthCriteria = pwd.length >= 8;
    const upperCase = /[A-Z]/.test(pwd);
    const number = /[0-9]/.test(pwd);
    const special = /[^A-Za-z0-9]/.test(pwd);
    const passed = [lengthCriteria, upperCase, number, special].filter(Boolean).length;

    if (!lengthCriteria) return "Weak";
    if (passed === 2 || passed === 3) return "Medium";
    if (passed === 4) return "Strong";
    return "Weak";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setPasswordError("");

    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters long");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const res = await fetch("/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
        credentials: "include",
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || "Something went wrong");
      }

      setMessage("Your password has been reset. Logging you in...");

      const meRes = await fetch("/auth/me", {
        credentials: "include",
      });
      const meData = await meRes.json();
      if (meRes.ok && meData.user) {
        setCurrentUser(meData.user);
        setTimeout(() => navigate("/"), 3000);
      } else {
        setError("Password reset succeeded but login failed");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  if (!token) return <div>Missing or invalid token</div>;

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src={`${process.env.PUBLIC_URL}/campwithfriends-logo.png`}
          alt="Camp With Friends Logo"
          style={{ width: "220px", marginBottom: "20px" }}
        />

        <h2>Set a new password</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="password"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordStrength(evaluatePasswordStrength(e.target.value));
            }}
            required
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          {password !== confirmPassword && confirmPassword.length > 0 && (
            <div className="error-text">Passwords do not match</div>
          )}

          {password && (
            <div className={`strength-text ${passwordStrength.toLowerCase()}`}>
              Strength: {passwordStrength}
            </div>
          )}

          {passwordError && <div className="error-text">{passwordError}</div>}

          <button type="submit">Reset password</button>
        </form>
        {message && <div className="success-text">{message}</div>}
        {error && <div className="error-text">{error}</div>}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
